/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redundant data that lets a code still scan when partly damaged. Levels range from Low (~7%) to High (~30%) recovery.`)
};

const es_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos redundantes que permiten que un código siga escaneándose aunque esté parcialmente dañado. Los niveles van de Baja (~7 %) a Alta (~30 %) de recuperación.`)
};

const de_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redundante Daten, die einen Code auch bei teilweiser Beschädigung noch lesbar machen. Die Stufen reichen von Niedrig (~7 %) bis Hoch (~30 %) Wiederherstellung.`)
};

const nl_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redundante gegevens waardoor een code nog steeds scant als hij deels beschadigd is. Niveaus lopen van Laag (~7%) tot Hoog (~30%) herstel.`)
};

const fr_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des données redondantes qui permettent à un code de rester scannable même partiellement endommagé. Les niveaux vont de Faible (~7 %) à Élevée (~30 % de récupération).`)
};

const it_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati ridondanti che permettono a un codice di essere ancora letto quando parzialmente danneggiato. I livelli vanno da Bassa (~7%) ad Alta (~30%) di recupero.`)
};

const pt_br2_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados redundantes que permitem que um código continue sendo lido mesmo parcialmente danificado. Os níveis vão de Baixa (~7%) a Alta (~30%) de recuperação.`)
};

const pt_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados redundantes que permitem que um código continue a ler-se mesmo parcialmente danificado. Os níveis vão da Baixa (~7%) à Alta (~30%) de recuperação.`)
};

const ja_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部が破損してもコードが読み取れるようにする冗長データです。レベルは低(約7%)から高(約30%)まであります。`)
};

const zh_qr_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一种冗余数据，可使二维码在部分损坏时依然能被扫描识别。级别从低（约 7%）到高（约 30%）不等的恢复能力。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_a2", locale)
	if (locale === "en") return en_qr_faq_a2(inputs)
	if (locale === "es") return es_qr_faq_a2(inputs)
	if (locale === "de") return de_qr_faq_a2(inputs)
	if (locale === "nl") return nl_qr_faq_a2(inputs)
	if (locale === "fr") return fr_qr_faq_a2(inputs)
	if (locale === "it") return it_qr_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_a2(inputs)
	if (locale === "pt") return pt_qr_faq_a2(inputs)
	if (locale === "ja") return ja_qr_faq_a2(inputs)
	return zh_qr_faq_a2(inputs)
};